import React, {useState, useEffect} from 'react';
import BlogView from "./BlogView";
import {connect} from "react-redux";
import {useParams} from "react-router-dom";
import {withRouter} from "react-router-dom";
import {getAllArticles} from "../KnowledgeBankAction";

function Blog(props) {
    const [blogsPageState, setBlogsPageState] = useState({
        articles: [],
        isApiInProgress: false,
        apiErrorMessage: '',
    });
    const {id} = useParams();

    useEffect(() => {
        setBlogsPageState(prevState => ({...prevState, isApiInProgress: true}));
        getAllArticles()
            .then(res => {
                if (res.success) {
                    setBlogsPageState(prevState => ({
                        ...prevState,
                        isApiInProgress: false,
                        articles: res.data,
                    }));
                } else {
                    setBlogsPageState(prevState => ({
                        ...prevState,
                        isApiInProgress: false,
                        apiErrorMessage: res.__error,
                    }));
                }
            });
    }, []);


    return (
        <BlogView
            {...props}
            {...blogsPageState}
            blogId={id}
        />
    );
}

const mapStateToProps = (state) => ({
    isMobileView: state.appState.deviceInfo.isMobileView,
    isMobileDevice: state.appState.deviceInfo.isMobileDevice,
    isLGView: state.appState.deviceInfo.isLGView,
    isXLView: state.appState.deviceInfo.isXLView,
    isXSView: state.appState.deviceInfo.isXSView,
    searchBlogText: state.appState.searchBlogText,
});

export default connect(mapStateToProps, {})(withRouter(Blog));
